import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RegepPersonalDataFormComponent } from './personal-data-form/regep-personal-data-form.component';
import { RegepTechnicalFormComponent } from './technical-form/regep-technical-form.component';
import { RegepDocumentsFormComponent } from './documents-form/regep-documents-form.component';
import { RegepResultComponent } from './components/regep-result/regep-result.component';
import { ModeratorGuardService } from '../+shared/guards/moderator-guard.service';
import { RegulatoryDataFormComponent } from './regulatory-data-form/regulatory-data-form.component';
import { ModeratorOrCustomerGuardService } from '../+shared/guards/moderator-customer-guard.service';
import { PendingChangesGuard } from '../+shared/guards/pending-changes-guard.servie';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'technical-data', component: RegepTechnicalFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'technical-data/:id', component: RegepTechnicalFormComponent, canDeactivate: [PendingChangesGuard] },
      {
        path: 'regulatory-data',
        component: RegulatoryDataFormComponent,
        canDeactivate: [PendingChangesGuard],
        canActivate: [ModeratorOrCustomerGuardService],
      },
      {
        path: 'regulatory-data/:id',
        component: RegulatoryDataFormComponent,
        canDeactivate: [PendingChangesGuard],
        canActivate: [ModeratorOrCustomerGuardService],
      },
      { path: 'personal-data', component: RegepPersonalDataFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'personal-data/:id', component: RegepPersonalDataFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'documents', component: RegepDocumentsFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'documents/:id', component: RegepDocumentsFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'result/:id', component: RegepResultComponent, canDeactivate: [PendingChangesGuard], canActivate: [ModeratorGuardService] },
    ]),
  ],
  exports: [RouterModule],
})
export class RegepRoutingModule {}
